import * as React from 'react';

const SvgVietnamFlag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    style={{
      enableBackground: 'new 0 0 512 512',
    }}
    xmlSpace="preserve"
    width="1em"
    height="1em"
    className="svg-icon"
    {...props}
  >
    <rect
      width="512"
      height="512"
      style={{
        fill: '#DA251D',
      }}
    />
    <polygon
      style={{
        fill: '#FFCD00',
      }}
      points="256,102.4 280.2,200.7 377.6,200.7 297.7,257.4 322,355.2 256,298.6 190,355.2 214.3,257.4 134.4,200.7 231.8,200.7"
    />
  </svg>
);

export default SvgVietnamFlag;
